export const RIGHTS = {
  NONE: 'NONE',
  READ: 'READ',
  WRITE: 'WRITE',
}

export const RESOURCES = {
  DASHBOARD_HOME_PAGE: 'DASHBOARD_HOME_PAGE',
  LISTINGS_PAGE: 'LISTINGS_PAGE',
  TRANSACTION_MANAGER_PAGE: 'TRANSACTION_MANAGER_PAGE',
  PROPERTIES_PAGE: 'PROPERTIES_PAGE',
  PACKAGES_PAGE: 'PACKAGES_PAGE',
  DOCUMENTS_PAGE: 'DOCUMENTS_PAGE',
  LISTING_ATTRIBUTES_PAGE: 'LISTING_ATTRIBUTES_PAGE',
  MARKETING_TAGS_PAGE: 'MARKETING_TAGS_PAGE',
  INVITATIONS_PAGE: 'INVITATIONS_PAGE',
  EVENTS_PAGE: 'EVENTS_PAGE',
  EVENT_PAGE: 'EVENT_PAGE',
  VENUES_PAGE: 'VENUES_PAGE',
  VENUE_PAGE: 'VENUE_PAGE',
  EVENT_TEMPLATES_PAGE: 'EVENT_TEMPLATES_PAGE',
  EVENT_TEMPLATE_PAGE: 'EVENT_TEMPLATE_PAGE',
  VENUE_TEMPLATES_PAGE: 'VENUE_TEMPLATES_PAGE',
  VENUE_TEMPLATE_PAGE: 'VENUE_TEMPLATE_PAGE',
  MORPHEUS_LOGS_PAGE: 'MORPHEUS_LOGS_PAGE',
  USERS_PAGE: 'USERS_PAGE',
  INTAKE_HUB_PAGE: 'INTAKE_HUB_PAGE',
  CLIENT_AUTHORIZATION_PAGE: 'CLIENT_AUTHORIZATION_PAGE',
  EMAIL_TEMPLATE_MANAGEMENT_PAGE: 'EMAIL_TEMPLATE_MANAGEMENT_PAGE',
  TINY_URL_PAGE: 'TINY_URL_PAGE',
  AUCTIONEER_DASHBOARD_PAGE: 'AUCTIONEER_DASHBOARD_PAGE',
  AUCTIONEER_LIVE_AUCTION_TRACKER_PAGE: 'AUCTIONEER_LIVE_AUCTION_TRACKER_PAGE',
  FINANCE_PAGE: 'FINANCE_PAGE',
  ORGANIZATIONS_PAGE: 'ORGANIZATIONS_PAGE',
  AI_EVALUATIONS_PAGE: 'AI_EVALUATIONS_PAGE',
  COMMUNICATIONS_PAGE: 'COMMUNICATIONS_PAGE',
  TRANSACTIONS_PAGE: 'TRANSACTIONS_PAGE',
  COMMUNICATION_CENTER_PAGE: 'COMMUNICATION_CENTER_PAGE',
}
